import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const autoEuropePricingIdDrawerData = signal({})
export const autoEuropePricingIdDrawerErrors = signal({})
export const autoEuropePricingIdListData = signal([])
export const autoEuropePricingIdIsLoading = signal(false)
export const autoEuropePricingIdIsSubmitting = signal(false)

export const isAutoEuropePricingIdDrawerOpen = computed(() => autoEuropePricingIdDrawerData.value && !isEmpty(autoEuropePricingIdDrawerData.value))

export const clearAutoEuropePricingIdSignals = () => batch(() => {
	autoEuropePricingIdDrawerData.value = {}
	autoEuropePricingIdDrawerErrors.value = {}
})